import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

import { withI18nQueryKey } from "~/shared/tanstack-query";

const ORDER = "order";
const CREATE = "create";
const DELETE = "delete";
const UPDATE = "update";
const UPDATE_SERVICES = "updateServices";
const SPECIFY_PAYMENT = "specifyPayment";
const GET = "get";
const GET_MANY = "getMany";
const CHANGE_STATUS = "changeStatus";
const GET_PAGINATED = "getPaginated";

const MUTATION_KEYS = {
  [CREATE]: [ORDER, CREATE],
  [UPDATE]: [ORDER, UPDATE],
  [UPDATE_SERVICES]: [ORDER, UPDATE_SERVICES],
  [DELETE]: [ORDER, DELETE],
  [CHANGE_STATUS]: [ORDER, CHANGE_STATUS],
  [SPECIFY_PAYMENT]: [ORDER, SPECIFY_PAYMENT],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(ORDER, {
  [GET]: (params: Parameters<Service[typeof GET]>[0]) => [params],
  [GET_MANY]: (params: Parameters<Service[typeof GET_MANY]>[0]) => [params],
  [GET_PAGINATED]: (params: Parameters<Service[typeof GET_PAGINATED]>[0], locale: string) =>
    withI18nQueryKey([params], { locale }),
});

export {
  CHANGE_STATUS,
  CREATE,
  DELETE,
  GET,
  GET_MANY,
  GET_PAGINATED,
  MUTATION_KEYS,
  QUERY_KEYS,
  SPECIFY_PAYMENT,
  UPDATE,
  UPDATE_SERVICES,
};
